var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    { attrs: { value: _vm.value, persistent: "", width: "800" } },
    [
      _c(
        "v-card",
        { staticClass: "grey lighten-3" },
        [
          _c(
            "v-toolbar",
            { attrs: { flat: "", dark: "", color: "#00aff0" } },
            [
              _c("v-toolbar-title", [
                _vm._v(" Edit " + _vm._s(_vm.attr.name) + " ")
              ]),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("update:value", false)
                    }
                  }
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              )
            ],
            1
          ),
          _c(
            "v-container",
            { staticClass: "pa-3 ma-0" },
            [
              _c(
                "v-row",
                { attrs: { align: "center", justify: "center" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "3" } },
                    [
                      _c(_vm.attrComponent, {
                        tag: "component",
                        attrs: {
                          attr: _vm.attr,
                          attrvalue: _vm.attrvalue,
                          attrvalues: _vm.attrvalues,
                          "no-focus": ""
                        },
                        on: { "save-attr": _vm.setNewValue }
                      })
                    ],
                    1
                  ),
                  !_vm.attrIsFeeAmount
                    ? _c(
                        "v-col",
                        { attrs: { cols: "3" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Fee Amount",
                              type: "number",
                              prefix: "$",
                              outlined: "",
                              dense: "",
                              "hide-details": "",
                              "background-color": "#fff",
                              rules: [_vm.isValidFee]
                            },
                            model: {
                              value: _vm.feeAmount,
                              callback: function($$v) {
                                _vm.feeAmount = $$v
                              },
                              expression: "feeAmount"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-col",
                    { attrs: { cols: "3" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          items: _vm.availableBillingCadences,
                          label: "Billing Cadence",
                          "item-text": "name",
                          "item-value": "id",
                          outlined: "",
                          dense: "",
                          "hide-details": "",
                          "background-color": "#fff"
                        },
                        model: {
                          value: _vm.billingCadence,
                          callback: function($$v) {
                            _vm.billingCadence = $$v
                          },
                          expression: "billingCadence"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-toolbar",
            { staticClass: "grey lighten-3", attrs: { flat: "" } },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "white--text",
                  attrs: {
                    color: "green",
                    disabled:
                      _vm.saveBtnDisabled ||
                      (_vm.isTruthy && (!_vm.billingCadence || !_vm.feeAmount))
                  },
                  on: {
                    click: function($event) {
                      _vm.valueExists
                        ? _vm.updateAttributeValue()
                        : _vm.saveAttributeValue()
                    }
                  }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.valueExists ? "Update" : "Save") + " "
                  ),
                  _c("v-icon", { attrs: { right: "" } }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.valueExists
                            ? "mdi-update"
                            : "mdi-content-save-outline"
                        ) +
                        " "
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }